/**
 * Algolia flattened jobs store some facets as strings; Typesense indexes them as string[].
 * UI (Hit cards) expects scalars for these fields.
 */
const ALGOLIA_SCALAR_FACET_FIELDS = [
  'normalisedRoleLevel',
  'field',
  'educationLevel',
] as const;

export type AlgoliaScalarFacetField = (typeof ALGOLIA_SCALAR_FACET_FIELDS)[number];

export function algoliaScalarFromIndexedFacetField(value: unknown): string | undefined {
  if (typeof value === 'string') {
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  if (Array.isArray(value)) {
    const first = value.find(
      (item): item is string => typeof item === 'string' && item.trim().length > 0,
    );
    return first ? first.trim() : undefined;
  }
  return undefined;
}

/**
 * Coerce Typesense string[] facet fields back to Algolia's string shape on search hits.
 */
export function normalizeAlgoliaFacetScalarFieldsOnHit(hit: Record<string, unknown>): void {
  for (const key of ALGOLIA_SCALAR_FACET_FIELDS) {
    if (!(key in hit)) continue;
    const scalar = algoliaScalarFromIndexedFacetField(hit[key]);
    if (scalar !== undefined) {
      hit[key] = scalar;
    } else {
      delete hit[key];
    }
  }
}
